var map = {
	"./2018_Parent_Resource_Guide.pdf": "ioDr",
	"./2018_TodoMath_ActivityBook_Final.pdf": "DVod",
	"./2018_TodoMath_BacktoSchool_Flyer.pdf": "5Gta",
	"./Sample_Parent_Email_BlackWhite-2.docx": "ZIbp",
	"./Sample_Parent_Email_Color.docx": "3UTL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zV5g";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files ^\.\/.*$
// module id = zV5g
// module chunks = 18